import { render, staticRenderFns } from "./base-modal.vue?vue&type=template&id=d73357de&scoped=true"
import script from "./base-modal.vue?vue&type=script&lang=js"
export * from "./base-modal.vue?vue&type=script&lang=js"
import style0 from "./base-modal.vue?vue&type=style&index=0&id=d73357de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73357de",
  null
  
)

export default component.exports